import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b2fb0f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }

import { PropType, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfilePhoto',
  props: {
  user: {
    type: Object as PropType<{
      id: string;
      first_name: string;
      last_name: string;
    }>,
    required: true,
  },
  size: {
    type: Number,
    required: false,
    default: 48,
  },
},
  setup(__props) {

const props = __props



const profilePhotoUrl = ref("");
const userInitials = ref("");
const styleAttribute = ref("");

function initialize() {
  profilePhotoUrl.value = "";

  if (props.user.id !== "__system__") {
    userInitials.value =
      `${props.user.first_name[0]}${props.user.last_name[0]}`.toUpperCase();
  } else {
    userInitials.value = "?";
  }

  styleAttribute.value = `width: ${props.size}px; height: ${
    props.size
  }px; font-size: ${props.size / 2}px`;
}

watch(
  () => props,
  () => {
    initialize();
  },
  { deep: true }
);

initialize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user-profile-photo", { 'user-initials': !profilePhotoUrl.value }]),
    "aria-hidden": "true",
    style: _normalizeStyle(styleAttribute.value)
  }, [
    (profilePhotoUrl.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: profilePhotoUrl.value,
          alt: ""
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(userInitials.value), 1))
  ], 6))
}
}

})